export default __webpack_public_path__ + "static/media/fridge1-before2-480w.dc3be896.png";